import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/organizationhistoriService"

import apiResponse from '../../../../../services/apiResponse'
// import DataTableBloc from '../Blocs/DataTableBloc'
import IndexBloc from '../../Index/Blocs/IndexBloc'
import MinioClient from '../../../../../services/minioClient'
import UpdateSKModal from "./UpdateSKModal"
import UpdateSPPModal from "./UpdateSPPModal"
import UpdateSPMTModal from "./UpdateSPMTModal"
import UpdateSPMJModal from "./UpdateSPMJModal"

const reformatDate = (date) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const d = new Date(date);
    let dt = d.getDate()
    if (dt < 10)
        dt = '0' + dt

    if (date) {
        return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return '-'
};

class TableComponent extends Component {

    indexBloc = new IndexBloc()
    minioClient = new MinioClient()
    source
    defaultOrder = 'employee_transfer_detail_id'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            updateUuid: null,
            approveUuid: null,
            inactiveUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter:
            {
                filter_value: "",
                page_number: 1,
                page_size: this.defaultSize,
                sort_order: {
                    column: this.defaultOrder,
                    order: this.defaultSort
                }
            }
        }
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {

        /* kirim ke server */
        let offset = (this.state.filter.page_number - 1) * this.state.filter.page_size
        if (this.state.defaultSize !== this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            uuid: this.props?.uuid,
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchListDetail(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.inactiveData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    inactiveData = async () => {
        await this.indexBloc.fetchInactiveDetail({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        this.setTokenAPI()

        this.indexBloc.listDetailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.indexBloc.inactiveDetailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.indexBloc.listDetailChannel?.unsubscribe()
        this.indexBloc.inactiveDetailChannel?.unsubscribe()
    }
    columns = [
        {
            key: "employee_transfer_detail_employee_full_name",
            text: "Pegawai",
            sortable: true,
            width: '25%',
            cell: record => {
                return (
                    <Fragment>
                        <b>{record.employee_nip}</b>
                        <br />{record.employee_transfer_detail_employee_full_name}<br />
                        <br /><b>Unit Kerja</b>
                        <br />{record.employee_transfer_detail_work_unit_name}
                        <br /><b>Jenis Jabatan</b>
                        <br />{record.position_jenis_fungsional_name}
                        <br /><b>Jabatan</b>
                        <br />{record.employee_transfer_detail_position_name}

                    </Fragment>
                )
            }
        },

        {
            key: "employee_transfer_detail_type",
            text: "Jenis Mutasi",
            sortable: false,
            width: '25%',
            cell: record => {
                var employee_transfer_detail_type_name = '';
                if (record.employee_transfer_detail_type == 1) {
                    employee_transfer_detail_type_name = "SK Pengangkatan Jabatan";
                }
                if (record.employee_transfer_detail_type == 2) {
                    employee_transfer_detail_type_name = "SK Pemberhentian & Pengangkatan Jabatan";
                }
                if (record.employee_transfer_detail_type == 3) {
                    employee_transfer_detail_type_name = "SK Pemberhentian Jabatan";
                }
                return (
                    <Fragment>
                        <b>{employee_transfer_detail_type_name}</b>
                    </Fragment>
                )
            }
        },
        {
            key: "info_dokumen",
            text: "Dokumen Mutasi",
            sortable: false,
            width: '50%',
            cell: record => {
                return (
                    <Fragment>
                        <ul className="m-0 mt-0" style={{ paddingLeft: "0.75rem" }}>
                            <li><b>Surat Keputusan &nbsp;&nbsp;
                                <a href="javascript:void(0)"
                                    onClick={() => this.setState(
                                        {
                                            StartSKModal: true,
                                            employee_transfer_detail_uuid: record.employee_transfer_detail_uuid,
                                            employee_nip: record.employee_nip,
                                            employee_transfer_detail_employee_full_name: record.employee_transfer_detail_employee_full_name,
                                            employee_transfer_detail_decree_date: record.employee_transfer_detail_decree_date,
                                            employee_transfer_detail_decree_number: record.employee_transfer_detail_decree_number,
                                            employee_transfer_detail_tmt_date: record.employee_transfer_detail_tmt_date,
                                            employee_transfer_detail_tmt_date_end: record.employee_transfer_detail_tmt_date_end,
                                            document_decree: record?.document_decree != null ? record?.document_decree?.documents_path : null
                                        }
                                    )}
                                >[update]</a></b>
                                <ul>
                                    <li><span style={{ minWidth: "100px", display: "inline-block" }}><b>Nomor SK</b></span> <b>:</b> {record.employee_transfer_detail_decree_number}</li>
                                    <li><span style={{ minWidth: "100px", display: "inline-block" }}><b>Tanggal SK</b></span> <b>:</b> {reformatDate(record.employee_transfer_detail_decree_date)}</li>
                                    <li><span style={{ minWidth: "100px", display: "inline-block" }}><b>TMT Mulai</b></span> <b>:</b> {reformatDate(record.employee_transfer_detail_tmt_date)}</li>
                                    <li><span style={{ minWidth: "100px", display: "inline-block" }}><b>TMT Berakhir</b></span> <b>:</b> {reformatDate(record.employee_transfer_detail_tmt_date_end)}</li>
                                    <li><span style={{ minWidth: "100px", display: "inline-block" }}><b>Dokumen</b></span> <b>:</b> {record?.document_decree != null ? <a target={"_blank"} href={record?.document_decree?.documents_path}>Download</a> : '-'}</li>
                                </ul>
                            </li>
                            {
                                (record.employee_transfer_detail_type == 1 || record.employee_transfer_detail_type == 2) &&
                                <Fragment>
                                    {
                                        (record.position_jenis_fungsional == 1) &&
                                        <li><b>Surat Pernyataan Pelantikan &nbsp;&nbsp;
                                            <a href="javascript:void(0)"
                                                onClick={() => this.setState(
                                                    {
                                                        StartSPPModal: true,
                                                        employee_transfer_detail_uuid: record.employee_transfer_detail_uuid,
                                                        employee_nip: record.employee_nip,
                                                        employee_transfer_detail_employee_full_name: record.employee_transfer_detail_employee_full_name,
                                                        employee_transfer_detail_decree_date: record.employee_transfer_detail_decree_date,
                                                        employee_transfer_detail_decree_number: record.employee_transfer_detail_decree_number,
                                                        employee_transfer_detail_tmt_date: record.employee_transfer_detail_tmt_date,
                                                        employee_transfer_detail_tmt_date_end: record.employee_transfer_detail_tmt_date_end,
                                                        employee_transfer_detail_spp_number: record.employee_transfer_detail_spp_number,
                                                        employee_transfer_detail_spp_date: record.employee_transfer_detail_spp_date,
                                                        employee_transfer_detail_spmt_number: record.employee_transfer_detail_spmt_number,
                                                        employee_transfer_detail_spmt_date: record.employee_transfer_detail_spmt_date,
                                                        employee_transfer_detail_spmj_number: record.employee_transfer_detail_spmj_number,
                                                        employee_transfer_detail_spmj_date: record.employee_transfer_detail_spmj_date,
                                                        document_decree: record?.document_spp != null ? record?.document_spp?.documents_path : null
                                                    }
                                                )}
                                            >[update]</a></b>
                                            <ul>
                                                <li><span style={{ minWidth: "100px", display: "inline-block" }}><b>Nomor SPP</b></span> <b>:</b> {record.employee_transfer_detail_spp_number}</li>
                                                <li><span style={{ minWidth: "100px", display: "inline-block" }}><b>Tanggal SPP</b></span> <b>:</b> {reformatDate(record.employee_transfer_detail_spp_date)}</li>
                                                <li><span style={{ minWidth: "100px", display: "inline-block" }}><b>Dokumen</b></span> <b>:</b> {record?.document_spp != null ? <a target={"_blank"} href={record?.document_spp?.documents_path}>Download</a> : '-'}</li>
                                            </ul>
                                        </li>
                                    }
                                    {
                                        (record.position_jenis_fungsional == 1 || record.position_jenis_fungsional == 3) &&
                                        <Fragment>
                                            <li><b>Surat Pernyataan Menduduki Jabatan &nbsp;&nbsp;<a href="javascript:void(0)"
                                                onClick={() => this.setState(
                                                    {
                                                        StartSPMJModal: true,
                                                        employee_transfer_detail_uuid: record.employee_transfer_detail_uuid,
                                                        employee_nip: record.employee_nip,
                                                        employee_transfer_detail_employee_full_name: record.employee_transfer_detail_employee_full_name,
                                                        employee_transfer_detail_decree_date: record.employee_transfer_detail_decree_date,
                                                        employee_transfer_detail_decree_number: record.employee_transfer_detail_decree_number,
                                                        employee_transfer_detail_tmt_date: record.employee_transfer_detail_tmt_date,
                                                        employee_transfer_detail_tmt_date_end: record.employee_transfer_detail_tmt_date_end,
                                                        employee_transfer_detail_spp_number: record.employee_transfer_detail_spp_number,
                                                        employee_transfer_detail_spp_date: record.employee_transfer_detail_spp_date,
                                                        employee_transfer_detail_spmt_number: record.employee_transfer_detail_spmt_number,
                                                        employee_transfer_detail_spmt_date: record.employee_transfer_detail_spmt_date,
                                                        employee_transfer_detail_spmj_number: record.employee_transfer_detail_spmj_number,
                                                        employee_transfer_detail_spmj_date: record.employee_transfer_detail_spmj_date,
                                                        document_decree: record?.document_spmj != null ? record?.document_spmj?.documents_path : null
                                                    }
                                                )}
                                            >[update]</a></b>
                                                <ul>
                                                    <li><span style={{ minWidth: "100px", display: "inline-block" }}><b>Nomor SPMJ</b></span> <b>:</b> {record.employee_transfer_detail_spmj_number}</li>
                                                    <li><span style={{ minWidth: "100px", display: "inline-block" }}><b>Tanggal SPMJ</b></span> <b>:</b> {reformatDate(record.employee_transfer_detail_spmj_date)}</li>
                                                    <li><span style={{ minWidth: "100px", display: "inline-block" }}><b>Dokumen</b></span> <b>:</b> {record?.document_spmj != null ? <a target={"_blank"} href={record?.document_spmj?.documents_path}>Download</a> : '-'}</li>
                                                </ul>
                                            </li>
                                        </Fragment>
                                    }

                                    <li><b>Surat Pernyataan Melaksakan Tugas &nbsp;&nbsp;<a href="javascript:void(0)"
                                        onClick={() => this.setState(
                                            {
                                                StartSPMTModal: true,
                                                employee_transfer_detail_uuid: record.employee_transfer_detail_uuid,
                                                employee_nip: record.employee_nip,
                                                employee_transfer_detail_employee_full_name: record.employee_transfer_detail_employee_full_name,
                                                employee_transfer_detail_decree_date: record.employee_transfer_detail_decree_date,
                                                employee_transfer_detail_decree_number: record.employee_transfer_detail_decree_number,
                                                employee_transfer_detail_tmt_date: record.employee_transfer_detail_tmt_date,
                                                employee_transfer_detail_tmt_date_end: record.employee_transfer_detail_tmt_date_end,
                                                employee_transfer_detail_spp_number: record.employee_transfer_detail_spp_number,
                                                employee_transfer_detail_spp_date: record.employee_transfer_detail_spp_date,
                                                employee_transfer_detail_spmt_number: record.employee_transfer_detail_spmt_number,
                                                employee_transfer_detail_spmt_date: record.employee_transfer_detail_spmt_date,
                                                employee_transfer_detail_spmj_number: record.employee_transfer_detail_spmj_number,
                                                employee_transfer_detail_spmj_date: record.employee_transfer_detail_spmj_date,
                                                document_decree: record?.document_spmt != null ? record?.document_spmt?.documents_path : null
                                            }
                                        )}
                                    >[update]</a></b>
                                        <ul>
                                            <li><span style={{ minWidth: "100px", display: "inline-block" }}><b>Nomor SPMT</b></span> <b>:</b> {record.employee_transfer_detail_spmt_number}</li>
                                            <li><span style={{ minWidth: "100px", display: "inline-block" }}><b>Tanggal SPMT</b></span> <b>:</b> {reformatDate(record.employee_transfer_detail_spmt_date)}</li>
                                            <li><span style={{ minWidth: "100px", display: "inline-block" }}><b>Dokumen</b></span> <b>:</b> {record?.document_spmt != null ? <a target={"_blank"} href={record?.document_spmt?.documents_path}>Download</a> : '-'}</li>
                                        </ul>
                                    </li>
                                </Fragment>
                            }




                        </ul>
                    </Fragment>
                )
            }
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.employee_transfer_detail_id
                return (
                    <Fragment>
                        {accessRole('delete') &&
                            <span>
                                <button
                                    className="btn btn-danger btn-sm"
                                    id={"delete-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            inactiveUuid: record.employee_transfer_detail_uuid,
                                            confirm: true
                                        })
                                    }}
                                    style={{
                                        padding: '2px 5px'
                                    }}>
                                    <i className="uil-trash-alt"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["delete" + thisId]: !this.state["delete" + thisId]
                                        })
                                    }}
                                >Hapus</Tooltip>
                            </span>
                        }
                    </Fragment>
                )
            }
        }
    ]
    previewDocument(urlPath) {
        // alert(urlPath)
        this.setState({
            loading: true
        })
        this.minioClient.get(urlPath).then((url) => {
            this.setState({
                loading: false
            })
            alert(url)
            window.open(url, "_blank")
        })
    }

    render() {
        return (
            <Fragment>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <UpdateSKModal
                    uuid={this.state.employee_transfer_detail_uuid}
                    nip={this.state.employee_nip}
                    nama={this.state.employee_transfer_detail_employee_full_name}
                    employee_transfer_detail_decree_date={this.state.employee_transfer_detail_decree_date}
                    employee_transfer_detail_decree_number={this.state.employee_transfer_detail_decree_number}
                    employee_transfer_detail_tmt_date={this.state.employee_transfer_detail_tmt_date}
                    employee_transfer_detail_tmt_date_end={this.state.employee_transfer_detail_tmt_date_end}
                    document_decree={this.state.document_decree}
                    modal={this.state.StartSKModal}
                    toggle={() => this.setState({ StartSKModal: !this.state.StartSKModal })}
                    handleReload={() => this.setTokenAPI()}
                />
                <UpdateSPPModal
                    uuid={this.state.employee_transfer_detail_uuid}
                    nip={this.state.employee_nip}
                    nama={this.state.employee_transfer_detail_employee_full_name}
                    employee_transfer_detail_decree_date={this.state.employee_transfer_detail_decree_date}
                    employee_transfer_detail_decree_number={this.state.employee_transfer_detail_decree_number}
                    employee_transfer_detail_tmt_date={this.state.employee_transfer_detail_tmt_date}
                    employee_transfer_detail_tmt_date_end={this.state.employee_transfer_detail_tmt_date_end}
                    employee_transfer_detail_spp_number={this.state.employee_transfer_detail_spp_number}
                    employee_transfer_detail_spp_date={this.state.employee_transfer_detail_spp_date}
                    employee_transfer_detail_spmt_number={this.state.employee_transfer_detail_spmt_number}
                    employee_transfer_detail_spmt_date={this.state.employee_transfer_detail_spmt_date}
                    employee_transfer_detail_spmj_number={this.state.employee_transfer_detail_spmj_number}
                    employee_transfer_detail_spmj_date={this.state.employee_transfer_detail_spmj_date}
                    document_decree={this.state.document_decree}
                    modal={this.state.StartSPPModal}
                    toggle={() => this.setState({ StartSPPModal: !this.state.StartSPPModal })}
                    handleReload={() => this.setTokenAPI()}
                />
                <UpdateSPMJModal
                    uuid={this.state.employee_transfer_detail_uuid}
                    nip={this.state.employee_nip}
                    nama={this.state.employee_transfer_detail_employee_full_name}
                    employee_transfer_detail_decree_date={this.state.employee_transfer_detail_decree_date}
                    employee_transfer_detail_decree_number={this.state.employee_transfer_detail_decree_number}
                    employee_transfer_detail_tmt_date={this.state.employee_transfer_detail_tmt_date}
                    employee_transfer_detail_tmt_date_end={this.state.employee_transfer_detail_tmt_date_end}
                    employee_transfer_detail_spp_number={this.state.employee_transfer_detail_spp_number}
                    employee_transfer_detail_spp_date={this.state.employee_transfer_detail_spp_date}
                    employee_transfer_detail_spmt_number={this.state.employee_transfer_detail_spmt_number}
                    employee_transfer_detail_spmt_date={this.state.employee_transfer_detail_spmt_date}
                    employee_transfer_detail_spmj_number={this.state.employee_transfer_detail_spmj_number}
                    employee_transfer_detail_spmj_date={this.state.employee_transfer_detail_spmj_date}
                    document_decree={this.state.document_decree}
                    modal={this.state.StartSPMJModal}
                    toggle={() => this.setState({ StartSPMJModal: !this.state.StartSPMJModal })}
                    handleReload={() => this.setTokenAPI()}
                />
                <UpdateSPMTModal
                    uuid={this.state.employee_transfer_detail_uuid}
                    nip={this.state.employee_nip}
                    nama={this.state.employee_transfer_detail_employee_full_name}
                    employee_transfer_detail_decree_date={this.state.employee_transfer_detail_decree_date}
                    employee_transfer_detail_decree_number={this.state.employee_transfer_detail_decree_number}
                    employee_transfer_detail_tmt_date={this.state.employee_transfer_detail_tmt_date}
                    employee_transfer_detail_tmt_date_end={this.state.employee_transfer_detail_tmt_date_end}
                    employee_transfer_detail_spp_number={this.state.employee_transfer_detail_spp_number}
                    employee_transfer_detail_spp_date={this.state.employee_transfer_detail_spp_date}
                    employee_transfer_detail_spmt_number={this.state.employee_transfer_detail_spmt_number}
                    employee_transfer_detail_spmt_date={this.state.employee_transfer_detail_spmt_date}
                    employee_transfer_detail_spmj_number={this.state.employee_transfer_detail_spmj_number}
                    employee_transfer_detail_spmj_date={this.state.employee_transfer_detail_spmj_date}
                    document_decree={this.state.document_decree}
                    modal={this.state.StartSPMTModal}
                    toggle={() => this.setState({ StartSPMTModal: !this.state.StartSPMTModal })}
                    handleReload={() => this.setTokenAPI()}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                {this.state.updateUuid !== null ?
                    <Redirect to={"/kepegawaian/mutasi_pegawai.html?updatemutasi&uuid=" + this.state.updateUuid} />
                    : null}
            </Fragment>
        )
    }
}

export default TableComponent;